export default function verticalSmoothScrollToPosition($selector, position, speed) {
    $selector.animate({
        scrollTop: position,
    }, speed);
}
